import showToastMessage from '../util/showToastMessage';
import { RejectedFile } from './fileAccept';

/**
 * Shared "we didn't attach these" toast, so every chat page reports a rejected
 * drop or pick the same way. Names at most two files — showToastMessage clips
 * its description at 80 characters.
 */
const notifyRejectedFiles = (rejected: RejectedFile[]) => {
  if (!rejected.length) return;

  const names = rejected.map((r) => r.file.name);
  const shown = names.slice(0, 2).join(', ');
  const label = names.length > 2 ? `${shown} and ${names.length - 2} more` : shown;
  const allTooMany = rejected.every((r) => r.reason === 'count');

  showToastMessage({
    type: 'warn',
    title: 'Some files were not attached',
    description: `${label} — ${allTooMany ? 'too many files at once.' : 'unsupported file type.'}`,
  });
};

export default notifyRejectedFiles;
